import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SnackbarInterceptor implements HttpInterceptor {
  private readonly snack_bar = inject(MatSnackBar);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const tractable = request.url.indexOf(environment.laravel_url) != -1 && request.url.indexOf('auth') == -1;
    const avoid_snackbar_notification = request.headers.get('avoid-snackbar-notification') !== null;

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        // avoid-snackbar-notification only suppresses success toasts; errors still surface
        if (tractable) {
          const detail = this.resolveErrorDetail(error);
          const message = `Error ${error.status}: ${detail}`;
          const duration = request.headers.get('X-Snackbar-Duration') ? parseInt(request.headers.get('X-Snackbar-Duration')!) : 3000;
          this.snack_bar.open(message, 'Ok', { duration });
        }
        return throwError(() => error);
      }),
      map((event: HttpEvent<unknown>): HttpEvent<unknown> => {
        if (event instanceof HttpResponse && tractable && !avoid_snackbar_notification) {
          switch (request.method) {
            case 'POST':
              this.snack_bar.open('Se ha creado correctamente.', 'Ok', { duration: 3000 });
              break;
            case 'PUT':
              this.snack_bar.open('Se ha actualizado correctamente', 'Ok', { duration: 3000 });
              break;
            case 'DELETE':
              this.snack_bar.open('Se ha borrado correctamente', 'Ok', { duration: 3000 });
              break;
          }
        }
        return event;
      })
    );
  }

  private resolveErrorDetail(error: HttpErrorResponse): string {
    const body: unknown = error.error;

    if (typeof body === 'string' && body.trim() !== '') {
      return body;
    }

    if (body && typeof body === 'object') {
      const record = body as Record<string, unknown>;

      // BusinessLogicException: { error: "..." }
      if (typeof record['error'] === 'string' && record['error'].trim() !== '') {
        return record['error'];
      }

      if (typeof record['message'] === 'string' && record['message'].trim() !== '') {
        return record['message'];
      }
    }

    return error.message;
  }
}
